import api from './api';
import { handleResponse, handleError } from './api';

const announcementService = {
  async list(eventId) {
    try { return handleResponse(await api.get(`/events/${eventId}/announcements`)); }
    catch (e) { return handleError(e); }
  },

  async create(eventId, { body, imageUrls }) {
    try { return handleResponse(await api.post(`/events/${eventId}/announcements`, { body, imageUrls })); }
    catch (e) { return handleError(e); }
  },

  async update(eventId, announcementId, { body, imageUrls }) {
    try { return handleResponse(await api.put(`/events/${eventId}/announcements/${announcementId}`, { body, imageUrls })); }
    catch (e) { return handleError(e); }
  },

  async delete(eventId, announcementId) {
    try {
      const r = await api.delete(`/events/${eventId}/announcements/${announcementId}`);
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },

  /**
   * Host uploads one image for an announcement (≤4 per post, no video).
   * POST /events/{eventId}/announcements/image (multipart `file`) → { url }.
   */
  async uploadImage(eventId, file) {
    try {
      const fd = new FormData();
      fd.append('file', file);
      return handleResponse(await api.post(`/events/${eventId}/announcements/image`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }));
    } catch (e) { return handleError(e); }
  },

  async markSeen(eventId, announcementId) {
    try {
      const r = await api.post(`/events/${eventId}/announcements/${announcementId}/seen`);
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },
};

export default announcementService;
